// extracted by mini-css-extract-plugin
export default {"gallery":"c-q_fS","gallery__header":"c-q_fT","gallery__thumbs":"c-q_fU"};